import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            h: remCalc(22),
            bg: 'background.base.default',
            borderRadius: 'full',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            overflow: 'hidden',
            pt: remCalc(2),
            pr: 'xxsmall.base',
            pl: 'xxxsmall-1.base',
            w: 'fit-content',
            boxShadow:
                '0 0 0 1px var(--border-neutral-highlight, #FFF) inset, 0 1px 2px 0 var(--neutral-xs, rgba(19, 24, 58, 0.08)), 0 0 0 1px var(--neutral-xs, rgba(19, 24, 58, 0.08))',
        },
    },
    variants: {
        plpReview: {
            h: remCalc(28),
        },
    },
}
